import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchCoreComponent } from './search-core.component';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule} from "ngx-bootstrap/popover";


@NgModule({
  declarations: [SearchCoreComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    FormsModule
  ],
  exports: [SearchCoreComponent]
})
export class SearchCoreModule { }
